import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import QRCode from "qrcode.react";
import localforage from "localforage";
import { Landmark } from "lucide-react";
import tokenService from "../../../../../utils/tokenService";

const Profiles = () => {
  const [profileData, setProfileData] = useState({
    uname: "",
    first_name: "",
    last_name: "",
    profile_image: "",
    phone_number: "",
    point: 0,
  });
  const [uName, setUName] = useState("");
  const [dataDisplayMyPosts, setDataDisplayMyPosts] = useState([]);
  const qrCodeCanvasRef = useRef(null);
  const inviteLink = `postperty.com/register?ID=${uName}`;
  const cookie = Cookies.get("jwt");

  const getToken = () => cookie;

  const handleFileUpload = async (event) => {
    const ImageUpload = event.target.files[0];
    const formData = new FormData();
    formData.append("image", ImageUpload);

    try {
      await axios.put(
        `${process.env.REACT_APP_API}/update/profile-image`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      Swal.fire("สำเร็จ!", "เปลี่ยนรูปโปรไฟล์สำเร็จ", "success");
      setTimeout(() => window.location.reload(), 2000);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchProfileData = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/user/getDataProfile`,
        {
          headers: { Authorization: `Bearer ${getToken()}` },
        }
      );
      setProfileData(response.data);
      setUName(response.data.uname);
      localStorage.setItem("profile_user", response.data.profile_image);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchMyPosts = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API}/asset/myassets`,
        {
          headers: {
            Authorization: `Bearer ${getToken()}`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      setDataDisplayMyPosts(response.data.assets);
    } catch (error) {
      console.error(error);
    }
  };

  const askLogout = () => {
    Swal.fire({
      title: "ต้องการออกจากระบบ?",
      text: "คุณจะถูกออกจากระบบและไม่สามารถใช้งานฟังก์ชันบางอย่างได้",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FF0000",
      cancelButtonColor: "#000",
      confirmButtonText: "ยืนยันการออกจากระบบ",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          // ต้องใช้ tokenService.logout() เท่านั้น
          // ถ้าลบ token มือ ๆ ตรงนี้ remember token จะค้างอยู่
          // แล้วผู้ใช้จะถูกพากลับเข้าระบบเองทันทีที่ไปหน้า login
          await localforage.removeItem("uploadData");
          await tokenService.logout();
          Swal.fire("สำเร็จ!", "ออกจากระบบเรียบร้อย", "success");
          window.location.replace("/login");
        } catch (err) {
          console.error("Error during logout", err);
          tokenService.clearToken();
          window.location.replace("/login");
        }
      }
    });
  };

  useEffect(() => {
    if (!cookie) window.location.replace("/login");
    fetchProfileData();
    fetchMyPosts();
  }, [cookie]);

  useEffect(() => {
    const checkJwtValidity = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API}/event/checkValidToken`,
          { token: cookie },
          { headers: { Authorization: `Bearer ${cookie}` } }
        );
        if (response.data.relogin) {
          Cookies.set("jwt", response.data.newjwt);
        }
      } catch (err) {
        if (err.response?.data?.success === false) {
          Cookies.remove("jwt");
          window.location.replace("/login");
        }
      }
    };

    checkJwtValidity();
  }, [cookie]);

  const formatPhoneNumber = (number) => {
    if (!number) return "";
    return number.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
  };

  const copyLinkInvite = async () => {
    await navigator.clipboard.writeText(inviteLink);
    Swal.fire("คัดลอกแล้ว", "ลิงก์แนะนำถูกคัดลอกไปยังคลิปบอร์ด", "success");
  };

  const SidebarItem = ({ to, iconSrc, label }) => (
    <Link to={to}>
      <div className="flex items-center gap-3 px-4 py-4 active:bg-gray-50 hover:bg-gray-50 transition-colors border-b border-gray-100 last:border-0 cursor-pointer">
        <div className="w-9 h-9 bg-gray-50 rounded-xl flex items-center justify-center flex-shrink-0">
          <img src={iconSrc} alt={label} className="w-5 h-5" />
        </div>
        <span className="flex-1 text-sm font-medium text-gray-700">{label}</span>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 text-gray-300 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M9 5l7 7-7 7" />
        </svg>
      </div>
    </Link>
  );

  return (
    <div className="min-h-screen bg-gray-50 lg:pt-0">
      {getToken() !== undefined ? (
        <div className="lg:mt-20 lg:max-w-7xl lg:mx-auto lg:px-6 lg:py-8 lg:flex lg:gap-5 lg:items-start px-4 py-4 lg:px-6 lg:py-8 space-y-3 lg:space-y-0">

          {/* ── LEFT SIDEBAR ── */}
          <div className="lg:w-72 lg:flex-shrink-0 lg:sticky lg:top-8 space-y-3">

            {/* Profile card */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-6 pt-6 pb-6">
              <div className="flex items-center justify-between mb-6">
                <h2 className="font-semibold text-gray-800">โปรไฟล์ของฉัน</h2>
                <Link to="/editprofile">
                  <span className="text-sm text-blue-600 font-medium px-3 py-1 bg-blue-50 rounded-full hover:bg-blue-100 transition-colors">
                    แก้ไข
                  </span>
                </Link>
              </div>

              {/* Avatar */}
              <div className="flex flex-col items-center mb-5">
                <div className="relative mb-3">
                  <form>
                    <input
                      type="file"
                      accept="image/*"
                      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                      onChange={handleFileUpload}
                    />
                    <img
                      src={profileData.profile_image}
                      alt="profile"
                      className="w-20 h-20 rounded-full object-cover ring-4 ring-gray-100"
                    />
                    <div className="absolute -bottom-1 -right-1 w-7 h-7 bg-white rounded-full shadow-md flex items-center justify-center border border-gray-200 z-20">
                      <img
                        src="https://cdn-icons-png.flaticon.com/512/44/44413.png"
                        alt="edit"
                        className="w-3.5 h-3.5"
                      />
                    </div>
                  </form>
                </div>
                <h3 className="font-semibold text-gray-900 text-base">
                  {profileData.first_name} {profileData.last_name}
                </h3>
                <div className="mt-2 px-4 py-2 bg-gray-50 rounded-xl border border-gray-100 w-full text-center">
                  <p className="text-xs text-gray-400 mb-0.5">User ID</p>
                  <p className="font-mono font-bold text-gray-800 text-sm">{uName}</p>
                </div>
              </div>

              {/* Phone */}
              <div className="pt-4 border-t border-gray-100">
                <p className="text-xs text-gray-400 mb-1">
                  เบอร์โทรศัพท์{" "}
                  <span className="text-gray-300">(ไม่แสดงต่อสมาชิกอื่น)</span>
                </p>
                <p className="text-sm font-medium text-gray-700">
                  {formatPhoneNumber(profileData.phone_number)}
                </p>
              </div>
            </div>

            {/* Nav menu */}
            <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
              <div className="px-4 py-2.5 border-b border-gray-100">
                <p className="text-xs font-semibold text-gray-400 uppercase tracking-wider">เมนู</p>
              </div>
              <SidebarItem to="/user/point" iconSrc="https://cdn-icons-png.flaticon.com/512/10693/10693084.png" label="คอมมิชชั่น" />
              <SidebarItem to="/profile/mypost" iconSrc="https://cdn-icons-png.flaticon.com/512/2333/2333043.png" label="ประกาศของฉัน" />
              <SidebarItem to="/profile/mylead" iconSrc="https://cdn-icons-png.flaticon.com/512/10473/10473571.png" label="Lead ของฉัน" />
              <SidebarItem to="/reference/invite" iconSrc="https://cdn-icons-png.flaticon.com/512/880/880594.png" label="แนะนำเพื่อน" />
              <SidebarItem to="/members/layer" iconSrc="https://cdn-icons-png.flaticon.com/512/9361/9361796.png" label="สมาชิกของฉัน" />
              <SidebarItem to="/profile/myshare" iconSrc="https://cdn-icons-png.flaticon.com/512/2099/2099122.png" label="การแชร์ทรัพย์" />
              <SidebarItem to="/profile/settings" iconSrc="https://cdn-icons-png.flaticon.com/512/10024/10024002.png" label="การตั้งค่า" />
              <div className="border-t border-gray-100">
                <button
                  onClick={askLogout}
                  className="w-full flex items-center gap-3 px-4 py-4 hover:bg-red-50 active:bg-red-50 transition-colors text-red-500"
                >
                  <div className="w-9 h-9 bg-red-50 rounded-xl flex items-center justify-center flex-shrink-0">
                    <img src="https://cdn-icons-png.flaticon.com/512/2529/2529508.png" className="w-5 h-5" alt="logout" />
                  </div>
                  <span className="text-sm font-medium">ออกจากระบบ</span>
                </button>
              </div>
            </div>
          </div>

          {/* ── MAIN CONTENT (desktop only) ── */}
          <div className="hidden lg:flex flex-1 gap-4 min-w-0">

            {/* Center column */}
            <div className="flex-1 flex flex-col gap-4 min-w-0">

              {/* Invite card */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex items-center gap-6">
                <div className="flex-shrink-0 p-2 bg-gray-50 border border-gray-100 rounded-xl" ref={qrCodeCanvasRef}>
                  <QRCode value={inviteLink} bgColor="#f9fafb" size={110} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs text-gray-400 uppercase tracking-wider mb-1">ลิงก์แนะนำเพื่อน</p>
                  <h3 className="text-lg font-bold text-gray-900 mb-3">POSTPERTY</h3>
                  <button
                    onClick={copyLinkInvite}
                    className="w-full flex items-center gap-2 px-4 py-2.5 bg-gray-50 border border-dashed border-gray-300 rounded-xl text-sm text-gray-500 hover:bg-gray-100 hover:border-gray-400 transition-all text-left"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4 flex-shrink-0 opacity-50" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
                      <path strokeLinecap="round" strokeLinejoin="round" d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
                    </svg>
                    <span className="truncate font-mono text-xs">{inviteLink}</span>
                  </button>
                </div>
              </div>

              {/* My Posts */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 flex-1">
                <h3 className="text-sm font-semibold text-gray-700 mb-4">ประกาศของฉัน</h3>
                {dataDisplayMyPosts.length > 0 ? (
                  <div className="grid grid-cols-3 gap-2">
                    {dataDisplayMyPosts.map((data, index) => (
                      <Link
                        key={index}
                        to={`/edit/${
                          data.type === "house" ? "house"
                          : data.type === "condo" ? "condo"
                          : data.type === "land" ? "land"
                          : data.type === "commercial" ? "commercial"
                          : ""
                        }/${data.id}`}
                        className="group relative block aspect-square overflow-hidden rounded-xl bg-gray-100"
                      >
                        <img
                          className="object-cover w-full h-full group-hover:scale-105 transition-transform duration-300"
                          src={data.images_url.AssetImagesURL[0]}
                          alt=""
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/25 to-transparent opacity-0 group-hover:opacity-100 transition-opacity rounded-xl" />
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="flex flex-col items-center justify-center py-16 text-gray-400">
                    <div className="w-14 h-14 bg-gray-100 rounded-full flex items-center justify-center mb-3">
                      <img src="https://cdn-icons-png.flaticon.com/512/2333/2333043.png" alt="" className="w-7 h-7 opacity-40" />
                    </div>
                    <p className="text-sm">คุณยังไม่มีโพสต์ที่ประกาศ</p>
                  </div>
                )}
              </div>
            </div>

            {/* Right column */}
            <div className="w-64 flex-shrink-0 flex flex-col gap-4">

              {/* Points card */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
                <div className="px-5 py-4 bg-gradient-to-br from-emerald-50 to-white">
                  <p className="text-xs text-gray-500 uppercase tracking-wider mb-1">ยอดเงินสะสม</p>
                  <div className="flex items-baseline gap-1.5">
                    <span className="text-3xl font-bold text-emerald-600">{profileData.point}</span>
                    <span className="text-base text-gray-500 font-medium">฿</span>
                  </div>
                </div>
                <div className="px-5 py-4 border-t border-gray-100">
                  <p className="text-xs font-semibold text-gray-500 mb-2">ช่องทางการรับเงิน</p>
                  <Link to="/user/point/bank">
                    <div className="flex items-center justify-between py-2.5 px-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors mb-2">
                      <div className="flex items-center gap-2.5">
                        {/* เดิม hotlink โลโก้จากเว็บกสิกรฯ ซึ่งตอบ 403 (บล็อกการลิงก์ข้ามเว็บ) เลยขึ้นรูปแตก
                            ใช้ไอคอนธนาคารกลาง ๆ จาก lucide แทน ไม่ต้องพึ่งเว็บนอก */}
                        <Landmark className="w-5 h-5 text-gray-500" strokeWidth={1.8} />
                        <span className="text-sm text-gray-700">เลือกช่องทาง</span>
                      </div>
                      <img src="https://cdn-icons-png.flaticon.com/512/271/271228.png" alt="" className="w-2.5 h-2.5 opacity-40" />
                    </div>
                  </Link>
                  <p className="text-xs font-semibold text-gray-500 mt-3 mb-2">ยืนยันตัวตน</p>
                  <Link to="/user/point/history">
                    <div className="flex items-center justify-between py-2.5 px-3 bg-gray-50 rounded-xl hover:bg-gray-100 transition-colors">
                      <div className="flex items-center gap-2.5">
                        <img src="https://cdn-icons-png.flaticon.com/512/3503/3503786.png" alt="history" className="w-5 h-5" />
                        <span className="text-sm text-gray-700">ตรวจสอบประวัติ</span>
                      </div>
                      <img src="https://cdn-icons-png.flaticon.com/512/271/271228.png" alt="" className="w-2.5 h-2.5 opacity-40" />
                    </div>
                  </Link>
                </div>
              </div>

              {/* Transaction history */}
              <div className="bg-white rounded-2xl shadow-sm border border-gray-100 flex-1 p-5">
                <p className="text-sm font-semibold text-gray-700 mb-3">ประวัติธุรกรรม</p>
                <div className="flex flex-col items-center justify-center h-28 text-gray-400">
                  <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mb-2">
                    <img src="https://cdn-icons-png.flaticon.com/512/3503/3503786.png" alt="" className="w-6 h-6 opacity-30" />
                  </div>
                  <p className="text-xs">ยังไม่มีประวัติธุรกรรม</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      ) : (
        <div>{window.location.replace("/login")}</div>
      )}
      <div style={{ height: "100px" }} />
    </div>
  );
};

export default Profiles;
